export enum ProcessControlService_Mode {
	UNKNOWN = "UNKNOWN",
	AUTOMATIC = "AUTOMATIC",
	SEMIAUTOMATIC = "SEMIAUTOMATIC",
	MANUAL = "MANUAL",
	PAUSED = "PAUSED",
	PLC = "PLC",
	STOPPED = "STOPPED"
}

export interface ProcessControlService_Status {
	mode: ProcessControlService_Mode,
	programs: number
	commands: number
	lastFinishTime: string | null
}

export interface TelemetryMessageProcessor_BathTelemetry {
	id: number
	temp: number | null
	voltage: number | null
	current: number | null
}

export interface CounterListItem {
	id: number;
	code: string;
	name: string;
	flags: number;

	value: number | null;
	valueDate: Date | null;

	resetValue: number | null;
	resetDate: Date | null;

	velocity: number | null;
	velocityBeforeReset: number | null;
}

export interface BadgeUpdate {
	id: number
	badges: Badge[]
}


export interface Badge {
	id: number
	label: string
	html: string
}